import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { RouterLink } from '@angular/router';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
  selector: 'app-integracao-home',
  imports: [ListaFuncionalidadeComponent, HeaderComponent, RouterLink],
  templateUrl: './integracao-home.component.html',
  styleUrl: './integracao-home.component.css',
})
export class IntegracaoHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Integracao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Integracao_Home;
  }
}
